<div class="row">
  <div *ngFor="let filter of currentFilters; index as i" class="col-lg-6 col-xl-3 col-sm-12 pt-1 pl-0">
    <div class="form-inline">
      <!--AND Label-->
      <div class="col-lg-1 pl-0 pr-0" *ngIf="showAddLabel(i)">
        <span class="btn btn-default btn-group-sm">AND</span>
      </div>

      <!--Filter-->
      <div class="pl-2 pr-2 pt-2 pb-2" [ngClass]="getBootstrapClass(filter, i)">
        <div class="form-inline">
          <ng-select
            [ngClass]="
              filter.key === 'location' ||
              filter.key === 'policyEffectiveDate' ||
              filter.key === 'lastSynced' ||
              filter.key === 'dueDate' ||
              filter.key === 'recommendationLetterDueDate' ||
              filter.key === 'recommendationLetterSentDate' ||
              filter.key === 'noOfRecommendations'
                ? 'col-lg-4 pl-0 pr-0'
                : 'col-lg-5 pl-0 pr-0'
            "
            placeholder="Choose a search parameter"
            [items]="filters"
            [clearable]="false"
            [readonly]="filter.value !== ''"
            bindLabel="label"
            bindValue="name"
            groupBy="group"
            [(ngModel)]="filter.key"
            (ngModelChange)="filterChanged($event, filter.key, 'key')">
            <ng-template ng-option-tmp let-item="item">
              <span [ngClass]="{ 'text-muted': item.disabled }">{{ item.label }}</span>
            </ng-template>
            <ng-template ng-optgroup-tmp let-item="item">
              {{ item.group || 'Unnamed group' }}
            </ng-template>
          </ng-select>

          <ng-container *ngIf="getConfiguration(filter.key) as config">
            <div
              *ngIf="filter.key !== null"
              style="text-align: center"
              class="pl-0 pr-0"
              [ngClass]="{
                'col-lg-4':
                  config.type === 'date' ||
                  config.type === 'text' ||
                  config.type === 'numberWightGreatterThanAndLessThan',
                'col-lg-2': !(
                  config.type === 'text' ||
                  config.type === 'date' ||
                  config.type === 'numberWightGreatterThanAndLessThan'
                )
              }">
              <!--Text Label-->
              <span *ngIf="config.type === 'textWithOr'">contains</span>
              <span *ngIf="config.type === 'text' && !config.hasOperator">in Radius of 10 miles from</span>

              <!--Multi Select Label-->
              <span *ngIf="config.type === 'select' && config.multi === true">is one of</span>

              <!--Single Select Label-->
              <span *ngIf="config.type === 'select' && !config.multi">is</span>

              <!--Date Options-->
              <select
                *ngIf="config.type === 'date'"
                class="form-control"
                [(ngModel)]="filter.operator"
                (ngModelChange)="filterChanged($event, filter.key, 'operator')">
                <option value="eq">Is</option>
                <option value="lte">Is Before</option>
                <option value="gte">Is After</option>
              </select>

              <!--Number Options-->
              <select
                *ngIf="config.type === 'text' && config.hasOperator"
                class="form-control"
                [(ngModel)]="filter.operator"
                (ngModelChange)="filterChanged($event, filter.key, 'operator')">
                <option value="lt">Less than</option>
                <option value="gt">More than</option>
              </select>

              <select
                *ngIf="config.type === 'numberWightGreatterThanAndLessThan'"
                class="form-control"
                [(ngModel)]="filter.operator"
                (ngModelChange)="filterChanged($event, filter.key, 'operator')">
                <option value="eq">Is</option>
                <option value="lte">less than</option>
                <option value="gte">more than</option>
              </select>
            </div>
          </ng-container>

          <ng-container *ngIf="getConfiguration(filter.key) as config">
            <div
              *ngIf="filter.key !== null"
              class="pl-0 pr-0"
              [ngClass]="{
                'col-lg-3':
                  (config.type === 'text' && config.hasOperator) ||
                  config.type === 'numberWightGreatterThanAndLessThan',
                'col-lg-4': config.type === 'date' || (config.type === 'text' && !config.hasOperator),
                'col-lg-5':
                  !(config.type === 'text') &&
                  config.type !== 'date' &&
                  config.type !== 'numberWightGreatterThanAndLessThan'
              }">
              <!--Text Input-->

              <!--Text Input with or-->
              <div
                *ngIf="config.type === 'textWithOr'"
                [id]="filter.key"
                #editableDivs
                contenteditable="true"
                class="form-control fullWidth"
                [class.placeholder]="filter.value === ''"
                (input)="onContentEdit(filter)"></div>

              <input
                *ngIf="config.type === 'numberWightGreatterThanAndLessThan'"
                type="text"
                class="form-control fullWidth"
                [(ngModel)]="filter.value"
                (ngModelChange)="filterChanged($event, filter.key, 'value')" />

              <!--Text Input without or but with operator ex: total TIV-->
              <input
                *ngIf="config.type === 'text' && config.hasOperator"
                type="text"
                class="form-control fullWidth"
                [(ngModel)]="filter.value"
                (ngModelChange)="filterChanged($event, filter.key, 'value')"
                placeholder="Text Input" />

              <!--Text Input without or but ex: coordinates-->
              <input
                *ngIf="config.type === 'text' && !config.hasOperator"
                type="text"
                class="form-control fullWidth"
                [ngClass]="{ 'error-border': validationErrors[filter.key] }"
                style="position: relative"
                [(ngModel)]="filter.value"
                (ngModelChange)="filterChanged($event, filter.key, 'value')"
                [placeholder]="config.placeholder" />
              <span *ngIf="config.type === 'text' && validationErrors[filter.key]" class="val-message">
                {{ config.validation.message }}
              </span>

              <!--Single Select Input-->
              <select
                *ngIf="config.type === 'select' && !config.multi"
                class="form-control fullWidth"
                [(ngModel)]="filter.value"
                (ngModelChange)="filterChanged($event, filter.key, 'value')">
                <option *ngFor="let t of config.options" [ngValue]="t.id" [disabled]="t.disabled">{{ t.label }}</option>
              </select>

              <!--Date Input-->
              <app-datepicker-input
                *ngIf="config.type === 'date'"
                [data]="filter.value"
                [ngModelType]="true"
                (valueChange)="setDate($event, filter, 'value')"
                [inputLabel]="' '"></app-datepicker-input>

              <!--Multi Select Input-->
              <ng-select
                *ngIf="config.type === 'select' && config.multi === true"
                bindValue="id"
                bindLabel="label"
                [multiple]="true"
                [items]="config.options"
                [(ngModel)]="filter.value"
                (ngModelChange)="filterChanged($event, filter.key, 'value')"
                [closeOnSelect]="false">
                <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                  <div class="ng-value" *ngFor="let item of items | slice: 0 : 1">
                    <span class="ng-value-label">{{
                      item.label.length > 8 ? item.label.substring(0, 8) + '...' : item.label
                    }}</span>
                    <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                  </div>
                  <div class="ng-value" *ngIf="items.length > 1">
                    <span class="ng-value-label">{{ items.length - 1 }} more...</span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                  <input id="item-{{ index }}" type="checkbox" name="item-{{ index }}" [ngModel]="item$.selected" />
                  {{ item.label }}
                </ng-template>
              </ng-select>
            </div>
          </ng-container>

          <div class="icon" (click)="onClickClearFilter(filter.key)" *ngIf="filter.value !== ''">
            <i class="fa fa-times-circle"></i>
          </div>
        </div>
      </div>

      <!--Add Button-->
      <div class="col-lg-1" *ngIf="showAddButton(filter, i)">
        <span class="btn btn-success" (click)="onClickShowButton()"><i class="fa fa-plus"></i></span>
      </div>
    </div>
  </div>
</div>
